import { Service } from '@angular/core';
import { Selector, State, StateContext } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { AddItems, RemoveItems } from '@portal-core/data/collection/types/collection-state.type';
import { TaskComment } from '@portal-core/tasks/models/task-comment.model';
import { Observable, map } from 'rxjs';

@CollectionStateSelectors({
  stateType: TaskCommentsState
})
@State<TaskCommentsState>({
  name: TaskCommentsState.source
})
@Service({ autoProvided: false })
export class TaskCommentsState extends CollectionStateBase {
  static override source = 'TaskComments';
  ByTaskId: { [taskId: number]: number[] } = {};

  getSource(): string {
    return TaskCommentsState.source;
  }

  override getAddItemsState(_ctx: StateContext<CollectionStateBase>, action: AddItems): this {
    let taskId: number;
    const comments = (<TaskComment[]>action.payload.items);
    for (const prop in comments) {
      if (comments[prop]
        && typeof comments[prop] !== 'function') {
        const comment = (<TaskComment>comments[prop]);
        if (!taskId) {
          taskId = comment.TaskId;
        }
        if (!(taskId in this.ByTaskId)) {
          this.ByTaskId[taskId] = [];
        }
        if (this.ByTaskId[taskId].indexOf(comment.Id) === -1) {
          this.ByTaskId[taskId].push(comment.Id);
        }
      }
    }
    return this;
  }

  override getRemoveItemsState(_ctx: StateContext<CollectionStateBase>, action: RemoveItems): this {
    const comments = action.payload.itemIds;
    for (const prop in comments) {
      if (comments[prop]
        && typeof comments[prop] !== 'function') {
        const assetId = (<number>comments[prop]);

        Object.entries(this.ByTaskId).forEach(([_key, value]) => {
          value.some(id => {
            if (id === assetId) {
              value.splice(value.indexOf(assetId), 1);
            }
            return id === assetId;
          });
        });
      }
    }
    return this;
  }

  override getResetState(): this {
    this.ByTaskId = {};
    return this;
  }
}

@Service()
export class TaskCommentsDataService extends CollectionDataServiceBase<TaskComment> {
  protected readonly stateType = TaskCommentsState;

  @Selector([TaskCommentsState])
  static getByTaskIdFn$(state: TaskCommentsState) {
    return (taskId: number) => {
      if (state.ByTaskId === undefined
        || !(taskId in state.ByTaskId)) {
        return undefined;
      }
      const comments = [];
      for (const prop in state.ByTaskId[taskId]) {
        if (state.ByTaskId[taskId][prop]
          && typeof (state.ByTaskId[taskId][prop]) !== 'function') {
          const comment = state.items[(state.ByTaskId[taskId][prop])];
          if (comment !== undefined) {
            comments.push(comment);
          }
        }
      }
      return comments;
    };
  }

  getItemsByTaskId$(taskId: number): Observable<TaskComment[]> {
    return this.store.select(TaskCommentsDataService.getByTaskIdFn$).pipe(map(getByTaskIdFn => getByTaskIdFn(taskId)));
  }
}
